export const qcellsData = {
  id: "qcells",
  title: "QCells VPP Platform Launch",
  result: "Operational VPP in 6 Months",
  img: "/images/qcells-panels.jpg", // Ensure this path is correct
  industry: "Energy",
  challenge:
    "Needed to rapidly deploy a scalable Virtual Power Plant (VPP) platform to manage distributed energy resources (DERs) and participate in grid services.",
  solution:
    "Leveraged LoyalShift's configurable VPP & DERMS Orchestration Platform, utilizing Universal Adapter™ for DER integration and AI-powered forecasting.",
  link: "/case-studies/qcells",
  quote:
    "LoyalShift's platform provided the core functionality we needed... [allowing us] to go from concept to operation in just six months.", // Example short quote
};
